<template>
  <b-skeleton-wrapper :loading="loading">
    <template #loading>
      <slot name="loading"></slot>
    </template>
    <slot name="default"></slot>
  </b-skeleton-wrapper>
</template>

<script>
import { toRefs } from "vue";
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    // generate props data
    const { loading } = toRefs(props);

    // return data to be used in template
    return { loading };
  },
};
</script>
